<template>
  <Dialog>
    <DialogTrigger class="btn btn-outline-dark">
      {{ $t('Show example') }}
    </DialogTrigger>
    <DialogScrollContent>
      <DialogHeader>
        <DialogTitle>
          {{ $t('Dynamic content example') }}
        </DialogTitle>
      </DialogHeader>
      <div class="table-responsive">
        <table class="table table-striped table-extra-padding">
          <thead>
          <tr>
            <th>{{ $t('Field') }}</th>
            <th>{{ $t('Value example') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(value, name, index) in data" :key="index">
            <td>
              <div class="input-group">
                <input type="text" class="form-control" :value="'{{dynamicContent.' + name + '}}'"
                       :id="'dynamicContentInput' + index" readonly>
                <div class="input-group-append">
                  <button type="button" class="btn btn-outline-secondary btn-copy"
                          :data-clipboard-target="'#dynamicContentInput' + index">
                    <i class="fa fa-clipboard"></i>
                  </button>
                </div>
              </div>
            </td>
            <td>{{ value }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </DialogScrollContent>
  </Dialog>
</template>

<script setup>
import ClipboardJS from "clipboard";
import { Dialog, DialogScrollContent, DialogTrigger, DialogHeader, DialogTitle } from "@/components/ui/dialog";

new ClipboardJS('.btn-copy');

const props = defineProps({
  data: {
    required: true,
    type: Object,
  }
});
</script>
